import ActivityItem from './ActivityItem';
import { useActivityData } from './hooks';

export default function ActivityList({ activities = [], title = 'Activité récente' }) {
  const formattedActivities = useActivityData(activities);

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-0">
        {formattedActivities.length > 0 ? (
          formattedActivities.map((activity, index) => (
            <ActivityItem
              key={index}
              initials={activity.initials}
              title={activity.title}
              description={activity.description}
              timestamp={activity.timestamp}
            />
          ))
        ) : (
          <p className="text-sm text-gray-500 text-center py-4">Aucune activité récente</p>
        )}
      </div>
    </div>
  );
}
